// extracted by mini-css-extract-plugin
export default {"privacy_txt":"index_privacy_txt_NqqCM"};